import {Component} from 'react'
import './index.css'

class CoinToss extends Component {
  state = {HeadC: 0, TailC: 0, Total: 0, Toss: 0}

  onClickToss = () => {
    const tossResult = Math.floor(Math.random() * 2)
    this.setState({Toss: tossResult})
    this.setState(previousState => ({
      Total: previousState.Total + 1,
    }))
    if (tossResult === 0) {
      this.setState(previousState => ({
        HeadC: previousState.HeadC + 1,
      }))
    } else {
      this.setState(previousState => ({
        TailC: previousState.TailC + 1,
      }))
    }
  }

  render() {
    const {HeadC, TailC, Total, Toss} = this.state
    const url =
      Toss === 0
        ? 'https://assets.ccbp.in/frontend/react-js/heads-img.png'
        : 'https://assets.ccbp.in/frontend/react-js/tails-img.png'

    return (
      <div className="whole">
        <div className="cont2">
          <h1>Coin Toss Game</h1>
          <p>Heads (or) Tails</p>
          <img src={url} className="img" alt="toss result" />
          <button type="button" onClick={this.onClickToss}>
            Toss Coin
          </button>
          <div className="cont3">
            <p>Total: {Total}</p>
            <p>Heads: {HeadC}</p>
            <p>Tails: {TailC}</p>
          </div>
        </div>
      </div>
    )
  }
}
export default CoinToss
